interface MutationFieldConfig {
  readonly mutationName: string
  readonly mutationConfig: any
}

export function buildRootMutationFields(
  fields: any,
  ...toMerge: MutationFieldConfig[]
): {
  readonly [key: string]: any
} {
  return toMerge.reduce((prev, curr) => {
    return {
      ...prev,
      [curr.mutationName]: curr.mutationConfig
    }
  }, fields)
}
